import script from "./ServerDatatableControls.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerDatatableControls.vue?vue&type=script&setup=true&lang=js"

import "./ServerDatatableControls.vue?vue&type=style&index=0&id=3b1de7d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1de7d8"]])

export default __exports__